import AbstractRest from "./AbstractRest.ts";
import axios, {AxiosResponse} from "axios";
import {SuccessResponseData} from "../types/ReturnHelpers.ts";
import {ICalibration, ICalibrationSpec} from "../types/models/Calibration.ts";

class CalibrationRest extends AbstractRest {

    constructor() {
        super("calibrations");
    }

    get_calibrations(calibration: Partial<ICalibration>): Promise<AxiosResponse<SuccessResponseData<ICalibration[]>>> {
        return axios.get(this.baseUrl + "/", {params: calibration});
    }

    get_calibrations_paged(limit: number): Promise<AxiosResponse<SuccessResponseData<ICalibration[]>>> {
        return axios.get(this.baseUrl + "/paged", {params: {limit}});
    }

    create(calibration: ICalibrationSpec): Promise<AxiosResponse<SuccessResponseData<ICalibration>>> {
        return axios.post(this.baseUrl, calibration)
    }

    delete(calibrationId: string) {
        return axios.delete(this.baseUrl + "/" + calibrationId)
    }
}

export default CalibrationRest;